




























































import { Component, Prop, Vue } from 'vue-property-decorator';
import Tribute, { TributeOptions } from 'tributejs';

@Component
export default class AMentionUser extends Vue {
  @Prop({ required: true })
  options!: TributeOptions<any>[];

  @Prop({ default: 'input' })
  elementType!: string;

  tributes: Tribute<any>[] = [];

  $target!: HTMLElement;

  mounted () {
    if (typeof Tribute === 'undefined') {
      throw new Error('Cannot locate tributejs!');
    }
    if (!this.$slots?.default?.length) {
      throw new Error('Cannot locate base element for tributejs to target!');
    } else {
      this.$target = this.$slots.default[0].elm as HTMLElement;
    }

    // bind each tribute option object to the target
    this.options.forEach((option) => {
      const newTribute = new Tribute(option);
      newTribute.attach(this.$target);

      this.tributes.push(newTribute);
    });

    this.$target.addEventListener('tribute-replaced', e => {
      // @ts-ignore
      e.target.dispatchEvent(new Event(this.elementType, { bubbles: true }));
    });
  }

  beforeDestroy () {
    // detach all tributes
    this.tributes.forEach((tribute) => {
      tribute.detach(this.$target);
    });
  }

  render (h) {
    return h(
      'div',
      {
        staticClass: 'v-tribute'
      },
      this.$slots.default
    );
  }
}
